import React, { useState, useEffect } from 'react';
import InputComponent from './Template_Components/InputComponent';
import TextareaComponent from './Template_Components/TextAreaComponent';
import SelectComponent from './Template_Components/SelectComponent';
import MultiSelect from './Template_Components/MultiSelectComponent';
import axios from 'axios'; // Import Axios
import { API_ROUTES, API_DOMAIN, headers } from './apiConfig';
import HiddenField from './Template_Components/HiddenField';

  const FormComponent = ({ fields, route, initialFormData,
    onSubmitSuccess = () => {},  // Default to a no-op function
  onSubmitError = () => {}  // Default to a no-op function

    }) => {

  const defaultValues = {};
  const [formData, setFormData] = useState(initialFormData || {});
  const [submitResult, setSubmitResult] = React.useState(null);
  
  const [isLoading, setLoading] = useState(false)
    fields.forEach((field) => {
      if (field.value !== undefined) {       
        defaultValues[field.name] = field.value;       
      }


    
    });
  
  useEffect(() => {     
      //first test if the data is already present for update purposes   
    if (initialFormData) {
      // Set initial form data if provided      
      setFormData(initialFormData);
    }
  }, [initialFormData]);
  
  const handleChange = (fieldName, value) => { 
     
      setFormData((prevData) => ({ ...prevData, ...defaultValues, [fieldName]: value }));
   
  
  };



  const handleFieldChange = (field, value) => {
   
        if (field.onChange) {
      
      // Call the specific onChange handler if provided
      setFormData((prevData) => ({
        ...prevData,
        [field.name]: value,
      }));
      
      field.onChange(value);
    } else {
      // Default behavior
      handleChange(field.name, value);
    }
  };
 

   const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true)
      
      const apiUrl = Object.keys(initialFormData).length > 0 ? `${API_DOMAIN}${API_ROUTES[route]}${formData['id']}/` : `${API_DOMAIN}${API_ROUTES[route]}`;
   
       const hasFileInput = fields.some((field) => field.type === 'file' && formData[field.name]);

       if (hasFileInput) {
         // If there's a file, set the appropriate Content-Type for file upload
         headers['Content-Type'] = 'multipart/form-data';
      
       }

     
      // Check if initialFormData exists to determine whether to use POST or PUT
  
      const axiosMethod = Object.keys(initialFormData).length > 0 ? axios.put : axios.post;



      
      const formDataObject = new FormData();

        // Append fields to FormData
        fields.forEach((field) => {
          if (field.type === 'file' && formData[field.name]) {
            // Append file to FormData
            formDataObject.append(field.name, formData[field.name]);
          } else {
            // Append other fields
            formDataObject.append(field.name, formData[field.name] || '');
          }
        });
       

          
      const response = await axiosMethod(apiUrl, formDataObject, { headers })

      onSubmitSuccess(response.data); // Call 

    
  
      setLoading(false)

      if (response.status === 201) {
        //console.log('Response from the backend 201:', response.data);
        setSubmitResult({ success: true, message: 'Data submitted successfully!' });
      } else if(response.status === 200) {
        //console.log('Response from the backend 200:', response.data);
        setSubmitResult({ success: true, message: 'Data submitted successfully!' });
      
      } else {
        //console.log('Response from the backend:', response.data);
        setSubmitResult({ success: false, message: 'Failed to submit data' });
      }
    } catch (error) {
      
      setSubmitResult({ success: false, message: 'Error submitting data' });
      //console.log('Error submitting data:', error);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} encType='multipart/form-data'>
      {fields.map((field) => {
        switch (field.type) {
          case 'textarea':
            return (
              <TextareaComponent
                key={field.name}
                label={field.label}
                value={formData[field.name] || field.value ||''}
                onChange={(value) => handleChange(field.name, value)}
              />
            );
          case 'select':
            return (
              <SelectComponent
              key={field.name}
              label={field.label}
              options={field.options}
              value={formData[field.name] || ''}
              onChange={(value) => handleFieldChange(field, value)}
            />
            
            );
            case 'hidden':
              return (
                <HiddenField
                key={field.name}
                value={field.value}
            
              />
              );
            case 'file':
              return (
                <InputComponent
                  key={field.name}
                  label={field.label}
                  type={field.type}
                  onChange={(e) => handleChange(field.name, e.target.files[0], true)}
                />
              );
            case 'checkbox':
              return (
                <InputComponent
                  key={field.name}
                  label={field.label}
                  type={field.type}
                  value={formData[field.name] || field.value ||''}
                  checked={formData[field.name] || field.value || "false"}
                  onChange={(e) => handleChange(field.name, e.target.checked)}
                />
              );
              case 'multiselect':
                return (
                  <MultiSelect
                    label={field.label}
                    options={field.options}
                    value={formData[field.name] || []} // Ensure it's an array of objects
                    onChange={(selectedOptions) => handleFieldChange(field, selectedOptions)} // Pass selected objects
                    placeholder={field.placeholder || 'Select...'}
                  />
                );
              
          default:
            return (
              <InputComponent
                key={field.name}
                label={field.label}
                type={field.type}
                value={formData[field.name] || field.defaultValue || field.value || ''}
                onChange={(e) => handleChange(field.name, e.target.value)}
               
                readOnly={field.readOnly} // Pass readOnly
              />
            );
        }
      })}
      <button type="submit">{isLoading ? 'Loading'  : 'Submit'}</button>

      {submitResult && (
        <div style={{ marginTop: '10px', color: submitResult.success ? 'green' : 'red' }}>
          {submitResult.message}
        </div>
      )}
    </form>
  );
};

export default FormComponent;
